import React, { createContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { CustomerContext } from './CustomerContext';
import initializeSocketOpts from '../../helpers/initializeSocketOpts';

export const SocketContext = createContext({});

// The app context provider component
const SocketContextProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const [coords, setCoords] = useState(null);
    const location = useLocation();

    const {
        customerData,
    } = useContext(CustomerContext);

    // socket.io initialization
    useEffect(() => {
        // Create socket instance
        const createSocketInstance = async () => {
            if (typeof io !== 'undefined') {
                // eslint-disable-next-line no-undef
                let namespace = '/customer';
                let opts = {};
                if (process.env.SOCKETIO_REMOTE_HOST) {
                    const result = initializeSocketOpts(process.env.SOCKETIO_REMOTE_HOST, namespace);
                    namespace = result.namespace;
                    opts = result.opts;
                    opts.withCredentials = true;
                }
                // eslint-disable-next-line no-undef
                setSocket(io(namespace, opts));
            }
        };
        createSocketInstance();
    }, []);

    // Get user coords
    useEffect(() => {
        // eslint-disable-next-line no-undef
        if (navigator.geolocation && customerData && Object.keys(customerData).length > 0) {
            // eslint-disable-next-line no-undef
            navigator.geolocation.getCurrentPosition(function(position) {
                setCoords({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                });
            }, () => {
                setCoords(null);
            });
        }
    }, [customerData]);

    // Handle store visits, globally.
    useEffect(() => {
        if (socket !== null) {
            const emitStoreVisitEvent = () => {
                const payload = {
                    coords,
                    requestUrl: location.pathname,
                };
                socket.emit('store:visit', payload);
            };
            emitStoreVisitEvent();
        }
        return () => {
            if (socket !== null) {
                // for a specific event
                socket.emit('store:leave', {});
            }
        };
    }, [socket, coords, location.pathname]);

    const contextValue = useMemo(() => ({
        socket,
    }), [socket]);

    return (<SocketContext.Provider
        value={contextValue}>
        {children}
    </SocketContext.Provider>);
};

SocketContextProvider.propTypes = {
    children: PropTypes.node,
};

export default SocketContextProvider;
